import { jsx as _jsx } from "react/jsx-runtime";
import { AdvancedMarker } from '@vis.gl/react-google-maps';
import RegularParkingSvg from '../svgs/RegularParkingSvg';
import { useHover } from '../../hooks/useHover';
import HoverParkingSvg from '../svgs/HoverParkingSvg';
import LotParkingSvg from '../svgs/LotParkingSvg';
import SelectedParkingSvg from '../svgs/SelectedParkingSvg';
import { googleCoordinates } from '../../utils/googleCoordinates';
import { MarkerMotionAnimation } from './MarkerMotionAnimation';
import { HoverMarkerMotionAnimation } from './HoverMarkerMotionAnimation';
export default function ParkingMarker({ position, testId, isSelected, lotMode, onClick }) {
    const { isHovered, hoverProps } = useHover();
    const handleClick = () => {
        if (onClick)
            onClick();
    };
    return (_jsx(AdvancedMarker, { position: googleCoordinates(position), onClick: handleClick, ...hoverProps, children: _jsx("div", { "data-testid": testId, children: _jsx(MarkerMotionAnimation, { children: isSelected ? (_jsx(SelectedParkingSvg, { testId: testId.append('selected') })) : isHovered ? (_jsx(HoverMarkerMotionAnimation, { animationKey: "hover", children: _jsx(HoverParkingSvg, { testId: testId.append('hover') }) })) : (_jsx(HoverMarkerMotionAnimation, { animationKey: "normal", children: lotMode ? (_jsx(LotParkingSvg, { testId: testId.append('lotRegular') })) : (_jsx(RegularParkingSvg, { testId: testId.append('regular') })) })) }) }) }));
}
